var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ((_vm.field.options || {}).collapse !== true)?_c('vuedraggable',{class:{
    'v-jd-container-wrapper': true,
    editing: this.form.editing === this.field.uuid
  },attrs:{"group":"jdesign","draggable":".drag-handler","ghost-class":"ghost","value":_vm.value},on:{"input":_vm.onInput}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }